import { LastDenouncesTableComponent } from './../../components/last-denounces-table/last-denounces-table.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgModule } from '@angular/core';

import { AgmCoreModule } from '@agm/core';

import { OcorrenceDetailsComponent } from '../ocorrences/ocorrence-details/ocorrence-details.component';
import { OcorrenceListComponent } from '../ocorrences/ocorrence-list/ocorrence-list.component';
import { BusLinesComponent } from './../../components/bus-lines/bus-lines.component';
import { ChartsModule } from './../../components/charts/charts.module';
import { ModalsModule } from './../../components/modals/modals.module';
import { MaterialModule } from './../../material.module';
import { HomeComponent } from './home.component';
import { MatDialogModule } from '@angular/material/dialog';
import { DialogShowGraphs } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { ImportunationDataComponent } from '../../components/importunation-data/importunation-data.component';
import { EtnografiaDataComponent } from '../../components/etnografia-data/etnografia-data.component';
import { HorarioDataComponent } from '../../components/horario-data/horario-data.component';

import { ComplaintsEffects } from './state/complaints.effects';
import * as fromComplaints from './state/complaints.reducer';
import { TrialAccessComponent } from './trial-access/trial-access.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
	declarations: [
		HomeComponent,
		BusLinesComponent,
		OcorrenceListComponent,
		OcorrenceDetailsComponent,
		DialogShowGraphs,
		LastDenouncesTableComponent,
		ImportunationDataComponent,
		HorarioDataComponent,
		EtnografiaDataComponent,
		TrialAccessComponent,
	],
	exports: [
		HomeComponent,
		ImportunationDataComponent,
		EtnografiaDataComponent,
		HorarioDataComponent,
		TrialAccessComponent,
	],
	imports: [
		StoreModule.forFeature('complaints', fromComplaints.complaintsReducer),
		EffectsModule.forFeature([ComplaintsEffects]),
		CommonModule,
		HomeRoutingModule,
		ReactiveFormsModule,
		MaterialModule,
		ModalsModule,
		TranslateModule,
		MatDialogModule,
		ChartsModule,
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyDVO2M65l7mXKNWwbAoW64HJk2c7o1kQl8',
		}),
	],
})
export class HomeModule {}
